export function initGoogleAnalytics() {
    if (window.ga) {
        return window.ga;
    }
    window.ga = function (...args) {
        (window.ga.q = window.ga.q || []).push(args);
    };
    return (...args) => window.ga(...args);
}
export function initQuantcast() {
    if (!window.__qc) {
        window._qevents = [];
    }
    return () => {
        if (window.__qc) {
            window.__qc.qpixelsent = [];
        }
        window._qevents.push(window._qoptions || {});
    };
}
export function initFacebookPixel() {
    if (window.fbq) {
        return window.fbq;
    }
    window.fbq = function (...args) {
        if (window.fbq.callMethod) {
            window.fbq.callMethod(...args);
        }
        else {
            window.fbq.queue.push(args);
        }
    };
    if (!window._fbq) {
        window._fbq = window.fbq;
    }
    window.fbq.push = window.fbq;
    window.fbq.loaded = true;
    window.fbq.version = '2.0';
    window.fbq.queue = [];
    return (...args) => window.fbq(...args);
}
//# sourceMappingURL=third-party.js.map